import { Link } from "react-router-dom";
import { displayDates, exhibitionStatus, focalToPosition } from "../utils/dates";

export const ExhibitionArchCard = ({ exhibition, className = "", showMeta = false }) => (
  <Link
    to={`/exhibitions/${exhibition.slug}`}
    data-testid={`show-card-${exhibition.slug}`}
    draggable={false}
    onDragStart={(e) => e.preventDefault()}
    className={`group block ${className}`}
  >
    <div className="overflow-hidden rounded-t-[999px]">
      <img
        src={exhibition.card_image}
        alt={exhibition.card_alt || exhibition.title}
        loading="lazy"
        draggable={false}
        style={{ objectPosition: focalToPosition(exhibition.card_focal) }}
        className="aspect-[4/5] w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.05]"
      />
    </div>
    {showMeta && (
      <p className="eyebrow mt-5 text-[0.65rem]">{exhibitionStatus(exhibition.start_date, exhibition.end_date)}</p>
    )}
    <h3 className={`h-condensed text-xl lg:text-2xl ${showMeta ? "mt-2" : "mt-5"}`}>{exhibition.title}</h3>
    <p className="mt-1.5 text-sm font-light">{exhibition.gallery}</p>
    {showMeta && (
      <>
        <p className="mt-1 text-sm font-light">
          {[exhibition.city, exhibition.country].filter(Boolean).join(", ")}
        </p>
        <p className="mt-1 text-sm font-light">{displayDates(exhibition)}</p>
      </>
    )}
  </Link>
);
